module.exports = "/assets/data/b3832b07c28e12d753f9a17f50113e6f-SK2.data.json";